import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import i3 from "../../component/img/i3.jpg";
import i10 from "../../component/img/i10.webp";
import BookWithUs from "../../component/BookWithUs";
import Faq from "../../component/Faq";

function Contact() {
  return (
    <>
      <Navbar />
    
      <section>
		<div class="form1 form-spac rows con-page">
			<div class="container"> 
				<div class="spe-title col-md-12">
					<h2><span>Contact us</span></h2>
					<div class="title-line">
						<div class="tl-1"></div>
						<div class="tl-2"></div>
						<div class="tl-3"></div>
					</div>
					<p>World's leading tour and travels Booking website,Over 30,000 packages worldwide. Book travel packages and enjoy your holidays with distinctive experience</p>
				</div>

		<div class="pg-contact row">
                        <div class="col-md-3 col-sm-6 col-xs-12 new-con new-con1">
                            <h2>A2Z <span>Yatra</span></h2>
                            <p>We Provide Outsourced Software Development Services To Over 50 Clients From 21 Countries.</p>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12 new-con new-con1"> <img src="img/contact/1.png" alt=""/>
                            <h4>Address</h4>
                            <p>28800 Orchard Lake Road, Suite 180 Farmington Hills, U.S.A.
                                <br/>Landmark : Next To Airport</p>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12 new-con new-con3"> <img src="img/contact/2.png" alt=""/>
                            <h4>CONTACT INFO:</h4>
                            <p> <a href="tel://0099999999" class="contact-icon">Phone: 01 234874 965478</a>
                                <br/> <a href="tel://0099999999" class="contact-icon">Mobile: 01 654874 965478</a>
                                <br/> <a href="mailto:mytestmail@gmail.com" class="contact-icon">Email: info@company.com</a> </p>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12 new-con new-con4"> <img src="img/contact/3.png" alt=""/>
                            <h4>Website</h4>
                            <p> <a href="#">Website: www.mycompany.com</a>
                                <br/> <a href="#">Facebook: www.facebook/my</a>
                                <br/> <a href="#">Blog: www.blog.mycompany.com</a> </p>
                        </div>
                    </div>				
			</div>
		</div>
	</section>

      <Footer />
    </>
  );
}

export default Contact;
